export { useMutation } from './useMutation';
//# sourceMappingURL=index.js.map